module.exports = __webpack_public_path__ + "static/img1-5fb76b0e881637263d86c1fdbb8168a0.jpg";